// extracted by mini-css-extract-plugin
module.exports = {"ethAddress":"EthAddress_ethAddress__2l9at","paper":"EthAddress_paper__3Q0dE","avatar":"EthAddress_avatar__1ekQv"};